<template>
  <div class="main-layout">
    <el-card class="yx-incomplete-page box-inner">
      <div class="div-scroll">
        <div class="tips-container">
          <div class="tips">
            <div class="title">
              <i class="el-icon-info"></i><span>温馨提示</span>
            </div>
            <p>1、请在到校后导航前往报到办理地点；</p>
            <p>
              2、现场办理时出示本人“报到二维码”，如点击移动端“现场报到”页面右上角二维码图标；
            </p>
          </div>
        </div>
        <div class="time-line-container">
          <el-timeline>
            <el-timeline-item
              :timestamp="item.handleTime"
              placement="top"
              v-for="(item, index) in linkList"
              :key="index"
              color="#0bbd87"
            >
              <el-card>
                <h4>办理环节：{{ item.linkName }}</h4>
                <p>
                  办事地点：{{ item.location.name }}
                  <i
                    class="el-icon-location location-icon"
                    @click="handleLocation(item)"
                  ></i>
                </p>
                <p>
                  状态：<span
                    :class="{ green: item.status == 1, red: item.status == 0 }"
                    >{{ item.status == 0 ? "未办理" : "已办理" }}</span
                  >
                </p>
                <!-- <p>办理人：{{ item.personId }}</p> -->
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <!-- 地图弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        title="具体位置"
        :visible.sync="dialogFormVisible"
        width="60%"
      >
        <div id="map" class="map-container" style="height: 500px"></div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
export default {
  name: "",
  data() {
    return {
      SUCCESS_CODE: "",
      linkList: [],
      dialogFormVisible: false,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.map = null;
  },
  beforeMount() {
    MapLoader();
  },
  mounted() {
    this.getLinkList();
  },
  methods: {
    //   获取学生个人办理事项列表
    getLinkList() {
      this.$http.get("/welcome-live/student-link/myLink").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.linkList = res.data.records;
        } else {
          this.$message.error(`${res.msg}`);
        }
      });
    },
    handleLocation(item) {
      this.dialogFormVisible = true;
      // this.title = "具体位置";
      this.$nextTick(() => {
        console.log(123);
        this.mapInit(item.location.lng, item.location.lat);
      });
    },
    // 地图初始化
    mapInit(lng, lat) {
      let map = new AMap.Map("map", {
        zoom: 14,
        // center: [110,24.590791],
        pitch: 60,
      });
      console.log(map);
      AMap.plugin(["AMap.ToolBar"], function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        map.addControl(
          new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true,
            position: "LB",
          })
        );
      });
      map.setCenter([lng, lat]);
      var marker = new AMap.Marker({
        position: [lng, lat],
        map,
      });

      this.map = map;
    },
  },
};
</script>

<style lang="less" scoped>
.tips-container {
  padding-left: 110px;
  .tips {
    margin-bottom: 15px;
    color: #787878;

    i.el-icon-info {
      vertical-align: middle;
      font-size: 18px;
      margin-right: 5px;
      color: #409eff;
    }

    .title {
      font-size: 16px;
      line-height: 30px;
      // padding-left: 25px;
      color: #5a5a5a;
    }

    p {
      text-indent: 2em;
      line-height: 26px;
    }
  }
}
</style>